import axios from 'axios';
import { apiUrl } from './apiConstants';

const language = localStorage.getItem('language') || 'en'

const instance = axios.create({
  baseURL: apiUrl,
  headers: {
    'Accept-Language': language
  }
});

instance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  error => Promise.reject(error)
);

export default instance;
